const TOLL_CHARGER_CMS_KEYS: Record<string, string> = {
  Bankoverførsel: 'TollChargerNameBankTransfer',
  Rykkergebyr: 'TollChargerNameReminderFee'
};

export default function getDisplayTollChargerName(
  tollChargerName: string | undefined,
  getContent: (systemId: string) => { content?: string } | undefined
): string {
  if (!tollChargerName) return '';
  const cmsKey = TOLL_CHARGER_CMS_KEYS[tollChargerName];
  if (!cmsKey) return tollChargerName;
  const content = getContent(cmsKey);
  return content?.content ?? tollChargerName;
}
